/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/MFGTransItemGridEditor.ts" />

namespace TabAurous.Production {

    import fld = TreeMakingItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class TreeMakingItemsEditor extends _Ext.MFGTransItemGridEditor<TreeMakingItemsRow> {



        protected getColumnsKey() { return "Production.TreeMakingItems"; }
        protected getDialogType() { return TreeMakingItemsDialog; }
        protected getLocalTextPrefix() { return TreeMakingItemsRow.localTextPrefix; }
        protected form: TreeMakingItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};
        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = true;
            return opt;
        }
        // #region Variables 
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = false;
        public TotalItems: number;
        public DismantlingType: number;


        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));

        }

        private Master;


        //protected onClick(e: JQueryEventObject, row: number, cell: number) {
        //    super.onClick(e, row, cell);



        //    var item = this.itemAt(row);
        //    var target = $(e.target);

        //    // if user clicks "i" element, e.g. icon
        //    if (target.parent().hasClass('inline-action'))
        //        target = target.parent();

        //    if (target.hasClass('inline-action')) {
        //        e.preventDefault();


        //        if (target.hasClass('delete-row')) {

        //            //TODO: Validate for TransItemID in RefTransItemID in Stock
        //            Q.confirm('Are you sure want to Delete? ', () => {
        //                var id = this.id(item);
        //                this.view.deleteItem(id);

        //            });

        //            this.view.refresh();
        //        }


        //    }
        //    this.view.refresh();

        //}
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.WeightFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.Weight).format = num;


            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }

        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Weight) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else {
                value = text;
            }
            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Weight && value > 0) {

                var issuedmetal = (this.parentDialog as TreeMakingDialog).form.MetalIssued.value;
                var consumedmetal = (this.parentDialog as TreeMakingDialog).form.MetalConsumed.value - item.Weight;
                if (value > (issuedmetal - consumedmetal)) {
                    q.Alert('Invalid Entry', 'Entered weight is more than available stock', 2999, false);

                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                else {

                    item[field] = value;

                    var newmetal = (this.parentDialog as TreeMakingDialog).form.IssueDetails.getItems()[0];
                    var IsAdded = item.BOMDetails.filter(x => x.ItemTypeId == 104 && q.ToBool(x.IsExisting) == false && x.AttributeId == newmetal.AttributeId);

                    if (IsAdded.length > 0) {
                        item.BOMDetails.forEach(function (bom) {
                            if (bom.AttributeId == newmetal.AttributeId) {
                                bom.Weight = item.Weight - (item.DiamondWeight / 5) - item.StoneWeight;
                                bom.PureWeight = (item.Weight - (item.DiamondWeight / 5) - item.StoneWeight) * newmetal.Purity;
                            }
                        })
                    }
                    else {
                        var newbom: TreeMakingBOMRow = {
                            AttributeId: newmetal.AttributeId,
                            BagNo: item.BagNo,
                            BomProductId: newmetal.ProductId,
                            CalcOnId: newmetal.CalcOnId,
                            Weight: item.Weight - (item.DiamondWeight / 5) - item.StoneWeight,
                            ItemTypeId: newmetal.ItemTypeId,
                            Line_No: item.Line_No,
                            Pieces: 0,
                            ProductId: item.ProductId,
                            RefTransId: item.RefTransId,
                            RefTransItemId: item.RefTransItemId,
                            PureWeight: (item.Weight - (item.DiamondWeight / 5) - item.StoneWeight) * newmetal.Purity,
                            Purity: newmetal.Purity,
                            IsExisting: false
                        }
                        item.BOMDetails.push(newbom);
                    }

                    item.BOMDetails.forEach(function (b) {
                        if (b.ItemTypeId == 104) {
                            item.NetWeight = + b.Weight;
                        }
                    })
                }
            }
            this.view.updateItem(id, item);
            this.view.refresh();
            (this.parentDialog as TreeMakingDialog).calculateItemDetailsData();
            (this.parentDialog as TreeMakingDialog).calculateMetalRequired();
            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


        // #endregion 

        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            buttons.push({
                title: "Select Bag",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => {

                    var stockgrid = Production.TreeMakingWIPMovement;

                    var departmentid = parseInt((this.parentDialog as TreeMakingDialog).form.DepartmentId.value);
                    var karatid = parseInt((this.parentDialog as TreeMakingDialog).form.KaratId.value);
                    var metalcolorid = parseInt((this.parentDialog as TreeMakingDialog).form.MetalColorId.value);
                    var baseweight = (this.parentDialog as TreeMakingDialog).form.BaseWeight.value == null ? 0 : (this.parentDialog as TreeMakingDialog).form.BaseWeight.value;
                    var treeweight = (this.parentDialog as TreeMakingDialog).form.TreeWeight.value == null ? 0 : (this.parentDialog as TreeMakingDialog).form.TreeWeight.value;
                    var conversionfactor = (this.parentDialog as TreeMakingDialog).form.ConversionFactor.value == null ? 0 : (this.parentDialog as TreeMakingDialog).form.ConversionFactor.value;
                    //var buttonweight = (this.parentDialog as TreeMakingDialog).form.ButtonWeight.value == null ? 0 : (this.parentDialog as TreeMakingDialog).form.ButtonWeight.value;

                    if (isNaN(departmentid) || isNaN(karatid) || isNaN(metalcolorid) || baseweight == 0 || treeweight == 0 || conversionfactor == 0 /*|| buttonweight == 0*/) {
                        q.alert('', 'All above values must be filled ', true, 2999);
                        return;
                    }

                    var filters: _Ext.SelectGridFilters = {
                        DepartmentId: departmentid,
                        KaratId: karatid,
                        MetalColorId: metalcolorid,
                    }
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: stockgrid, multiple: true, title: "Select Items",
                        preSelectedKeys: this.value.map(k => k.ProductId)
                    });
                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var self = this;
                        var details = [];

                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value: Production.WIPMovementRow) {


                            let wipbomdetails;
                            var bomdetails = [];
                            Production.WIPTransactionService.MFGBOMList({ BagNo: value.BagNo }, response => wipbomdetails = response.Entities, { async: false });

                            // #region Product Attributes
                            // **** Load & assign Attributes of Product using AtbID ****

                            wipbomdetails.forEach(function (bomvalue: Production.WIPTransactionRow) {

                                var bom: TreeMakingBOMRow = {
                                    AttributeId: bomvalue.AttributeId,
                                    BagNo: bomvalue.BagNo,
                                    BomProductId: bomvalue.ProductId,
                                    ProductId: value.ProductId,
                                    ItemTypeId: bomvalue.ItemTypeId,
                                    CalcOnId: bomvalue.CalcOnId,
                                    Line_No: bomvalue.Line_No,
                                    Pieces: bomvalue.Pieces,
                                    Weight: bomvalue.Weight,
                                    PureWeight: bomvalue.PureWeight,
                                    Purity: bomvalue.Purity,
                                    RefTransBomId: 0,
                                    RefTransId: bomvalue.TransId,
                                    RefTransItemId: 0,
                                    RefVoucherId: bomvalue.VoucherTypeId,
                                    IsExisting: true
                                };
                                bomdetails.push(bom);
                            });
                            var purchase: TreeMakingItemsRow = {
                                ProductId: value.ProductId,
                                AttributeId: value.AttributeId,
                                MovementId: value.MovementId,
                                Line_No: value.Line_No,
                                BagNo: value.BagNo,
                                HasBom: value.HasBom,
                                CalcOnId: value.CalcOnId,
                                DepartmentId: value.DepartmentId,
                                ProductCode: value.ProductCode,
                                ItemTypeId: value.ItemTypeId,
                                Pieces: value.Pieces,
                                Weight: 0,
                                OtherPieces: isNaN(value.OtherPieces) ? 0 : value.OtherPieces,
                                OtherWeight: isNaN(value.OtherWeight) ? 0 : value.OtherWeight,
                                StonePieces: isNaN(value.StonePieces) ? 0 : value.StonePieces,
                                StoneWeight: isNaN(value.StoneWeight) ? 0 : value.StoneWeight,
                                NetWeight: isNaN(value.NetWeight) ? 0 : value.NetWeight,
                                DiamondPieces: isNaN(value.DiamondPieces) ? 0 : value.DiamondPieces,
                                DiamondWeight: isNaN(value.DiamondWeight) ? 0 : value.DiamondWeight,
                                BOMDetails: bomdetails,
                                RefTransId: value.TransId,
                                RefTransItemId: value.TransItemId,
                            };

                            details.push(purchase);

                        });


                        for (let Detail of details) {
                            Detail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(Detail);
                        }

                        // #endregion

                        // #endregion
                    }

                    pickerDialog.element.bind('dialogclose', () => {
                        this.element.trigger('dialogclose');

                    });


                    pickerDialog.dialogOpen();
                }
            });
            return buttons;
        }

    }
}